import {
  BannerPrimary,
  BannerTertiary,
} from '@sbercloud/uikit-product-site-banner';
import { SectionBasic } from '@sbercloud/uikit-product-site-section';
import cn from 'classnames';
import { useRouter } from 'next/navigation';
import { MouseEvent as ReactMouseEvent, useMemo } from 'react';

import { useAnalytics } from '../../../hooks/useAnalytics';
import { useLayoutType } from '../../../hooks/useLayoutType';
import s from './FreeTierBanner.module.scss';

type FreeTierBannerProps = {
  title?: string;
  withoutWrapper?: boolean;
  className?: string;
  variant?: 'default' | 'small';
};

const buttonText = `Подробнее`;
const buttonHref = '/offers/free-test';
const defaultTitle = `
    Дарим 20 000 бонусов <br/>
    <span class="bold">для юрлиц и ИП</span>
`;

function Banner({ title, variant }: FreeTierBannerProps) {
  const layoutType = useLayoutType();
  const { clickAnalytics } = useAnalytics();
  const router = useRouter();

  const { bannerButton, bannerProps } = useMemo(() => {
    const bannerProps = {
      title: title ?? defaultTitle,
      img: 'https://cdn.cloud.ru/backend/images/banners/free_tier.png',
      layoutType,
      appearance: 'brand',
    } as const;

    const bannerButton = {
      label: buttonText,
      href: buttonHref,
      onClick(e: ReactMouseEvent<HTMLElement, MouseEvent>) {
        e.preventDefault();

        clickAnalytics({
          action: buttonHref,
          clickZone: 'body',
          clickContent: buttonText,
          clickElement: 'button',
          uniqueId: `promo-banner-freeze-button-${title}`,
          transitionType: 'inside-link',
          clickZoneCategory: 'site-body',
          transitionUrl: buttonHref,
          transitionTypeMetrics: 'internal',
        });

        router.push(buttonHref);
      },
    };

    return { bannerProps, bannerButton };
  }, [clickAnalytics, layoutType, router, title]);

  return variant === 'small' ? (
    <BannerTertiary {...bannerProps} button={bannerButton} description={''} />
  ) : (
    <BannerPrimary
      {...bannerProps}
      buttons={[bannerButton]}
      imgType="rectangle"
    />
  );
}

export function FreeTierBanner({
  title,
  variant = 'default',
  withoutWrapper = false,
  className = '',
}: FreeTierBannerProps) {
  const layoutType = useLayoutType();

  return (
    <>
      <SectionBasic
        layoutType={layoutType}
        className={cn(className, { [s.sectionWithoutWrap]: withoutWrapper })}
      >
        <Banner title={title} variant={variant} />
      </SectionBasic>
    </>
  );
}
